import { useNetworkState } from '@register-ui/utils';
import { InternetRequiredView } from './internet-required-view';
import { type PropsWithChildren } from 'react';

export function OnlineProtectedView({ children }: Readonly<PropsWithChildren>) {
    const { isOnline } = useNetworkState();

    if (!isOnline) {
        return <InternetRequiredView />;
    }

    return children;
}
